import React from "react";

type PillarProps = {
  colour?: string;
  width?: number;
  height?: number;
};

export const Pillar: React.FC<PillarProps> = ({
  colour = "lightgrey",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>House Pillar Icon</title>
      <rect
        x="10"
        y="10"
        width="80"
        height="80"
        fill={colour}
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};
